import { Component, Input, OnInit } from '@angular/core';
import { DatePourcentagePipe } from '../../pipes/date-pourcentage.pipe';
import { DatePipe } from '@angular/common';
import { TuiCompass } from '@taiga-ui/kit';
import { TuiHint } from '@taiga-ui/core';
import { Intervention } from '../../models/intervention';

@Component({
  selector: 'app-intervention-list-timeline',
  standalone: true,
  imports: [
    DatePourcentagePipe,
    DatePipe,
    TuiCompass,
    TuiHint
  ],
  templateUrl: './intervention-list-timeline.component.html',
  styleUrl: './intervention-list-timeline.component.scss'
})
export class InterventionListTimelineComponent implements OnInit {
  @Input() interventionList: Intervention[] | undefined;
  dateDebut: Date | undefined;
  dateFin: Date | undefined;

  ngOnInit(): void {
    if (this.interventionList && this.interventionList.length > 0) {
      // Trouver la date la plus ancienne
      this.dateDebut = this.interventionList.reduce((prev, curr) =>
        !prev.dateDeRealisation ||
          (curr.dateDeRealisation &&
            prev.dateDeRealisation < curr.dateDeRealisation)
          ? prev
          : curr
      ).dateDeRealisation;

      // Trouver la date la plus récente
      this.dateFin = this.interventionList.reduce((prev, curr) =>
        !prev.dateDeRealisation ||
          (curr.dateDeRealisation &&
            prev.dateDeRealisation > curr.dateDeRealisation)
          ? prev
          : curr
      ).dateDeRealisation;
    }
  }
}
